import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { StatusNotification } from '../../StatusNotification/StatusNotification';

type DyjDisabledMessageProps = Omit<ComponentProps<typeof StatusNotification>, 'description' | 'type'> & {
  show: boolean;
};

/**
 * DyjDisabledMessage extends StatusNotification component, with pre-set:
 *  - type === 'info'
 *  - description === translation key of 'lotteries.ticket_details.dyj_cancelled_message'
 *
 * @param show - boolean value, will render component if true and return null in case of false
 * @returns StatusNotification component with type info
 */
function DyjDisabledMessage({ show, ...props }: DyjDisabledMessageProps) {
  const t = useTranslations('lotteries.ticket_details');
  if (!show) return null;
  return <StatusNotification description={t('dyj_cancelled_message')} type="info" {...props} />;
}

export { DyjDisabledMessage };
